import React from 'react';

const History = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 5.75H3V4.25H17V5.75ZM12 10.75H3V9.25H12V10.75ZM15 15.75H3V14.25H15V15.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default History;
